import { connect } from "react-redux";
import React, { Component, Fragment } from "react";
import { addStepSurvey } from "../../../../redux/actions/surveyActions";
import { Checkbox, Tabs } from "antd";
import _ from "lodash";

const CheckboxGroup = Checkbox.Group;

class SectorsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      surveySecteurs: [],
      secteurList: this.props.sectorList,
      indeterminate: true,
      checkAll: false
    };
  }

  componentDidMount() {
    const { currentSectors = [] } = this.props;
    const sectorsChecked = [];

    for (let i = 0; i < currentSectors.length; i++) {
      const currentSector = currentSectors[i];
      if (currentSector.sector_id) {
        sectorsChecked.push(currentSector.sector_id);
      }
    }

    this.setCheckAllStates(sectorsChecked);
  }

  setCheckAllStates(checkedValues) {
    const { sectorList = [] } = this.props;

    this.setState({
      checkAll: sectorList.length === checkedValues.length,
      indeterminate: checkedValues.length > 0 && sectorList.length !== checkedValues.length
    });
  }

  onCheckAllChange = e => {
    if (e.target.checked) {
      //check all
      const { sectorList = [] } = this.props;
      this.onChange(sectorList.map(v => v.sector_id));
    } else {
      //uncheck all
      this.onChange([]);
    }
  };

  onChange = (checkedValues, a, b, c) => {
    const { sectorList = [] } = this.props;
    this.setCheckAllStates(checkedValues);
    //add sectors to reducer
    let surveyProgress = this.props.surveyProgress;
    surveyProgress.pdcs = surveyProgress.pdcs || [];

    //get current sectors ids to compare
    const currentSectors = surveyProgress.sectors || [];
    const currentSectorsIds = [];

    let selectSecteurs = [];
    //surveyProgress.pdcs = surveyProgress.pdcs || [];

    _.forEach(checkedValues, (secteur, index) => {
      const sector = _.find(sectorList, { sector_id: secteur });
      if (sector) {
        selectSecteurs.push({
          label: sector.sector_label,
          sector_id: sector.sector_id,
          sector_label: sector.sector_label
        });
      }
    });

    let zipSecteurs = _.zipObject(["sectors"], [selectSecteurs]);
    _.assign(surveyProgress, zipSecteurs);
    this.props.addStepSurvey(surveyProgress);

    for (let i = 0; i < currentSectors.length; i++) {
      const currentSector = currentSectors[i];
      if (currentSector.sector_id) {
        currentSectorsIds.push(currentSector.sector_id);
      }
    }

    //remove pdcs from removed sectors
    if (currentSectorsIds.length > checkedValues.length) {
      for (let i = 0; i < currentSectorsIds.length; i++) {
        const currentSectorsId = currentSectorsIds[i];
        if (checkedValues.indexOf(currentSectorsId) === -1) {
          const sector = _.find(sectorList, { sector_id: currentSectorsId });
          if (sector && sector.pdcs && sector.pdcs.length > 0) {
            surveyProgress.pdcs = surveyProgress.pdcs.filter(item => !sector.pdcs.includes(item));
          }
        }
      }
    } else {
      //add pdcs from removed sectors
      for (let i = 0; i < checkedValues.length; i++) {
        const checkedValue = checkedValues[i];
        if (currentSectorsIds.indexOf(checkedValue) === -1) {
          console.log(checkedValue);
          console.log("add all pdcs from sector " + checkedValue);
          const sector = _.find(sectorList, { sector_id: checkedValue });
          if (sector && sector.pdcs && sector.pdcs.length > 0) {
            const pdcsToAdd = [];
            for (let j = 0; j < sector.pdcs.length; j++) {
              const pdc = sector.pdcs[j];
              if (_.findIndex(this.props.availablesPDCs, { pdc_id: pdc }) !== -1) {
                pdcsToAdd.push(pdc);
              }
            }
            surveyProgress.pdcs = _.union(surveyProgress.pdcs, pdcsToAdd);
          }
        }
      }
    }

		if(surveyProgress.pdcs.length === 0){
			surveyProgress.usePdcs = false;
		}

		setTimeout(() => {
			this.props.addStepSurvey(surveyProgress);
		}, 300);
	};

  render() {
    const { sectorList = [], currentSectors = [] } = this.props;
    const sectorsChecked = [];

    for (let i = 0; i < currentSectors.length; i++) {
      const currentSector = currentSectors[i];
      if (currentSector.sector_id) {
        sectorsChecked.push(currentSector.sector_id);
      }
    }

    return (
      <Fragment>
        {sectorList.length > 1 && (
          <div
            className={`p-survey-longblock p-mrg-right-s p-mrg-top ${this.state.checkAll ? "selected" : ""}`}
            style={{ borderColor: "#515151" }}
          >
            <Checkbox
              indeterminate={this.state.indeterminate}
              onChange={e => this.onCheckAllChange(e)}
              checked={this.state.checkAll}
            >
              <span className={`${this.state.checkAll ? "p-txt-bold p-clr-blck" : ""}`}>Tout cocher</span>
            </Checkbox>
          </div>
        )}
        <CheckboxGroup style={{ width: "100%" }} onChange={this.onChange} value={sectorsChecked}>
          {sectorList.map((sector, index) => {
            let checked = sectorsChecked.indexOf(sector.sector_id) !== -1;
            return (
              <div
                className={`p-survey-longblock p-mrg-right-s p-mrg-top ${checked ? "selected" : ""}`}
                key={sector.sector_label}
              >
                <Checkbox value={sector.sector_id}>
                  <span className={`${checked ? "p-txt-bold p-clr-blck" : ""}`}>{sector.sector_label}</span>
                </Checkbox>
              </div>
            );
          })}
        </CheckboxGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const surveyProgress = state.survey.surveyManager.surveyProgress || {};
  const models = surveyProgress.model || [];
  let model = models.length > 0 ? models[0] : {};
  const retailerId = model.idRetailer || "";
  const pdcs = state.sectors.pdcs || [];
  const availablesPDCs = [];

  for (let i = 0; i < pdcs.length; i++) {
    const pdc = pdcs[i] || {};
    if (pdc.retailer_id === retailerId) {
      availablesPDCs.push(pdc);
    }
  }
  return {
    surveyProgress: state.survey.surveyManager.surveyProgress,
    sectorList: state.survey.surveyManager.sectorList,
    availablesPDCs: availablesPDCs
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addStepSurvey: survey => {
      dispatch(addStepSurvey(survey));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SectorsView);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSecteur/SectorsView.js